import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="shift_status"
export default class extends Controller {
    static values = { shiftId: Number }

    connect() {
        console.log('Shift status controller connected');
        // Optional: Add any initialization logic here
    }

    handle(event) {
        // Check if the clicked element or one of its parents is a shift-toggle-button
        let shiftButton = event.target.closest('.shift-toggle-button');
        if (shiftButton) {
            let shiftId = shiftButton.getAttribute('data-shift-id');
            this.toggleShiftStatus(shiftId, shiftButton);
        }
        // const button = event.target;
        // event.preventDefault(); // Prevent default button action
    }

    toggleShiftStatus(shiftId, shiftButton) {
        const id = shiftId;
        const button = shiftButton;

        fetch(`/shifts/${id}/toggle_mini_shift_status`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
            }
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                this.updateUI(button, data);  // Call to update UI with data
            })
            .catch(error => {
                console.error('Error:', error);
                // Handle error, such as showing a notification
            });
    }

    updateUI(button, data) {
        // Assuming 'data' contains the HTML for the new button and status display
        if (data.newButtonHTML && data.newStatusHTML) {
            let parentContainer = button.closest('.shift-status-and-button');

            if (parentContainer) {
                // Replace the HTML content of the button and status display
                parentContainer.innerHTML = `<span class="shift-status">${data.newStatusHTML} ${data.newButtonHTML}</span>`;
            }
        }
    }
}

